import React, { useCallback, useState } from 'react';
import { Button } from 'reactstrap';

import { useNotify } from 'js/hooks/useNotify';
import formatRubricSaveError from '../formatRubricSaveError';
import { isPlainDocumentObject } from '../rubricDocumentDirtyCheck';
import { useRubricContext } from './RubricContext';
import styles from './RubricEditor.module.scss';

export default function RubricEditorSaveBar({ onSave, saveName }) {
  const notify = useNotify();
  const { rubric } = useRubricContext();
  const [submitting, setSubmitting] = useState(false);

  const handleClick = useCallback(() => {
    if (!onSave || !rubric) {
      return;
    }

    const document = rubric.document;
    if (!isPlainDocumentObject(document)) {
      notify({
        type: 'danger',
        message: 'Document must be a JSON object.',
      });
      return;
    }

    const name = (saveName ?? '').trim();
    if (!name) {
      notify({
        type: 'danger',
        message: 'Name is required (see the form below).',
      });
      return;
    }

    setSubmitting(true);
    onSave({ name, document })
      .then(() => {
        notify({
          type: 'success',
          message: 'Rubric changes saved.',
        });
      })
      .catch((err) => {
        const text = formatRubricSaveError(err);
        notify({
          type: 'danger',
          message: text,
        });
      })
      .finally(() => setSubmitting(false));
  }, [notify, onSave, rubric, saveName]);

  if (!onSave) {
    return null;
  }

  const nameTrimmed = (saveName ?? '').trim();
  const canSave = Boolean(rubric && nameTrimmed);

  return (
    <div className={styles['rubric-editor-save-bar']}>
      <Button
        color="primary"
        type="button"
        disabled={submitting || !canSave}
        onClick={handleClick}
      >
        {submitting ? 'Saving…' : 'Save changes'}
      </Button>
    </div>
  );
}
